import { createContext, useContext } from 'react';

export type TutorialType = 'QUICK_REPORTS' | 'ENGAGEMENTS_HUB';

export type TutorialsContextProps = {
  activeTutorial: TutorialType | null;
  openTutorial: (val: TutorialType) => void;
  closeTutorial: (tutorial: TutorialType, dontShowAgain: boolean) => void;
};

export const TutorialsContext = createContext<TutorialsContextProps>({
  activeTutorial: null,
  closeTutorial: () => {},
  openTutorial: () => {}
});

export const TutorialsProvider = TutorialsContext.Provider;

export function useTutorialsContext() {
  return useContext<TutorialsContextProps>(TutorialsContext);
}
